module.exports = __webpack_public_path__ + "static/img/news2.b748e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/news2.jpg
// module id = 9mM8
// module chunks = 0